import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import PublisherCard from '../../components/publisherCard';
import usePublisher from '../../../store/models/publisher/usePublisher';
import * as styles from './styles';

function Recommended({ subscriber, onSync, onShare }) {
    const { recommendedPublishers } = usePublisher();

    // Only render for logged-in users with recommendations
    if (!subscriber || !recommendedPublishers.length) return null;

    function renderSectionHeader() {
        return (
            <Box sx={styles.sectionHeader}>
                <Box>
                    <Typography sx={styles.eyebrow}>
                        Recommended for you
                    </Typography>
                    <Typography variant="h2" sx={styles.title}>
                        Picks based on what you{' '}
                        <Box component="span" sx={styles.gradientCool}>
                            already follow
                        </Box>
                    </Typography>
                    <Typography sx={styles.subtitle}>
                        We exclude publishers you already follow and weight your industries 2× location and popularity.
                    </Typography>
                </Box>
            </Box>
        );
    }

    function renderGrid() {
        return (
            <Box sx={styles.grid}>
                {recommendedPublishers.map((publisher) => (
                    <PublisherCard
                        key={publisher.id}
                        publisher={publisher}
                        onSync={onSync}
                        onShare={onShare}
                    />
                ))}
            </Box>
        );
    }

    return (
        <Box component="section" sx={styles.section}>
            <Container maxWidth="xl">
                {renderSectionHeader()}
                {renderGrid()}
            </Container>
        </Box>
    );
}

export default Recommended;
